
'use strict';

import gsap from "gsap";
import CustomEase from "gsap/CustomEase";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(CustomEase);
gsap.registerPlugin(ScrollTrigger)

export function SetAnimation() {

  const loadings = document.querySelector(".js-loadings");
  const body = document.querySelector("body");
  const content = document.querySelector(".l-content");
  const page = document.querySelector(".l-page");
  const movie = document.querySelector(".movie-area");

  const txtM = document.querySelector('.loading-txt__mild-item--01');
  const txtW = document.querySelector('.loading-txt__wild-item--01');


  // CustomEase
  const customEase01 = CustomEase.create("custom", "M0,0 C0.899,-0.039 0.426,1.427 1,1 ");

  let mm = gsap.matchMedia();


  // set
  // mv
  gsap.set('.mv__txt', {
    opacity: 0,
    scale: 5
  });
  gsap.set('.mv__lead-txt--01', {
    opacity: 0,
    x: -300,
  });
  gsap.set('.mv__lead-txt--02', {
    opacity: 0,
    scale: 5
  });
  gsap.set('.mv__lead-txt--03', {
    opacity: 0,
    scale: 0
  });

  // pc
  mm.add('(min-width: 768px)', () => {
    gsap.set('.mv__pkg--01', {
      opacity: 0,
      x: 20,
      rotate: 20,
    });
  })
  mm.add('(max-width: 767px)', () => {
    gsap.set('.mv__pkg--01', {
      opacity: 0,
      x: 0,
      rotate: 0,
      y: -30
    });
  })

  mm.add('(min-width: 768px)', () => {
    gsap.set('.mv__pkg--02', {
      opacity: 0,
      x: 20,
      rotate: 20,
    });
  })
  mm.add('(max-width: 767px)', () => {
    gsap.set('.mv__pkg--02', {
      opacity: 0,
      x: 0,
      rotate: 0,
      y: -30
    });
  })


  // question
  gsap.set('.question__ttl', {
    opacity: 0,
    y: 50
  });
  gsap.set('.question__people-mark', {
    opacity: 0,
    rotate: 20
  });
  gsap.set('.question__lead', {
    opacity: 0,
    scale: 5
  });

  // wild
  gsap.set('.wild__ttl-pop', {
    opacity: 0,
    scale: 3
  });
  gsap.set('.wild__ttl-txt--01', {
    opacity: 0,
    x: -250,
    scale: 0.3
  })
  gsap.set('.wild__ttl-txt--02', {
    opacity: 0,
    y: 100,
  });
  gsap.set('.wild__txt-item', {
    opacity: 0,
    scale: 1,
    x: -400
  });
  gsap.set('.wild__fuku', {
    y: 1500,
  });

  // get-wild
  gsap.set('.get-wild__txt', {
    opacity: 0,
    scale: 5,
  });



  function MvAnimation() {
    const tl = gsap.timeline();

    tl.add(() => {
      txtM.classList.add('is-hidden');
      txtW.classList.add('is-show');
    })
    tl.to('.loading-txt__mild-item--02', {
      opacity: 0,
      duration: 1.5,
      ease: 'power2.out'
    })
    tl.to('.loading-txt__wild-item--02', {
      opacity: 1,
      duration: 1.5,
      ease: 'power2.out'
    }, '-=1.5')
    tl.to('.loading-wild', {
      opacity: 1,
      duration: 1.5,
      ease: 'power2.out'
    }, '-=1.5')

    tl.add(() => {
      loadings.classList.add('is-hidden');
      content.classList.remove('is-fixed');
      body.classList.remove('is-fixed');
      page.classList.add('is-show');
      movie.classList.add('is-show');
    })


    tl.to('.mv__txt', {
      opacity: 1,
      scale: 1,
      duration: 0.3,
      ease: customEase01
    },'+=0.7')
    tl.to('.mv__lead-txt--01', {
      opacity: 1,
      x: 0,
      scale: 1,
      ease: customEase01,
      duration: 0.8,
    }, '-=0.2')
    tl.to('.mv__lead-txt--02', {
      opacity: 1,
      scale: 1,
      ease: customEase01,
      duration: 0.5,
    }, '-=0.2')
    tl.to('.mv__lead-txt--03', {
      opacity: 1,
      scale: 1,
      ease: customEase01,
      duration: 0.5,
    }, '-=0.2')
    tl.to('.mv__pkg--01', {
      opacity: 1,
      x: 0,
      rotate: 0,
      duration: 0.3,
      y: 0
    }, '-=0.2')
    tl.to('.mv__pkg--02', {
      opacity: 1,
      x: 0,
      rotate: 0,
      duration: 0.3,
      y: 0
    },'-=0.1')

  }

  function questionAnimation() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.question',
        start: 'top 50%',
      },
    });
    tl.to('.question__ttl', {
      opacity: 1,
      y: 0,
      ease: 'power1.out',
      duration: 0.3,
    })
    tl.to('.question__people-mark', {
      opacity: 1,
      rotate: 0,
      ease: 'power1.out',
      duration: 0.3,
      stagger: {
        from: "start",
        each: 0.3
      }
    })
    tl.to('.question__lead', {
      opacity: 1,
      scale: 1,
      ease: customEase01,
      duration: 0.5,
    }, '-=0.2')
    tl.add(() => {
      document.querySelector('.question__btn').classList.add('is-active');
    },'-=0.3')
  }

  function wildAnimation() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.wild',
        start: 'top 50%',
      },
    });
    tl.to('.wild__ttl-pop', {
      opacity: 1,
      scale: 1,
      ease: customEase01,
      duration: 0.3,
    })
    tl.to('.wild__ttl-txt--01', {
      opacity: 1,
      x: 0,
      scale: 1,
      ease: customEase01,
      duration: 0.4,
    }, '-=0.1')
    tl.to('.wild__ttl-txt--02', {
      opacity: 1,
      y: 0,
      ease: 'power1.out',
      duration: 0.5,
    })
    tl.to('.wild__fuku', {
      y: 0,
      ease: 'power1.out',
      duration: 0.7,
    }, '-=0.3')
    tl.to('.wild__txt-item', {
      opacity: 1,
      x: 0,
      scale: 1,
      ease: customEase01,
      duration: 0.5,
      stagger: {
        from: "start",
        each: 0.4
      }
    })
    gsap.timeline({
      scrollTrigger: {
        trigger: '.get-wild',
        start: 'top 50%',
      },
    }).to('.get-wild__txt', {
      opacity: 1,
      scale: 1,
      ease: customEase01,
      duration: 0.6,
    })
  }


  body.classList.add("is-fixed");
  content.classList.add("is-fixed");




  window.addEventListener('load', () => {
    questionAnimation();
    wildAnimation();
    $('html,body').animate({ scrollTop: 0 }, '0.2');
    setTimeout(() => {
      MvAnimation();
    },600)
  })


}
